import { useContext, FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { CheckoutServerVarsContext } from '../../components/shared/CheckoutServerVarsContext';
import classNames from 'classnames';

import styles from '../creditCard/styles/CheckoutCreditCardMessage.scss';

import { CheckoutBankAccountMessage_transaction$data } from './__generated__/CheckoutBankAccountMessage_transaction.graphql';

type Props = {
    transaction?: CheckoutBankAccountMessage_transaction$data;
};

const CheckoutBankAccountMessage: FunctionComponent<Props> = ({ transaction }) => {
    const { isMobile } = useContext(CheckoutServerVarsContext);
    const isPrivateOffer = transaction?.isPrivateOffer;
    const isShippingKnown = transaction?.isShippingKnownAtCheckout;
    return isPrivateOffer && isShippingKnown ? null : (
        <div className={classNames(styles.message, { [styles.isResponsiveLayout]: !isMobile })}>
            <FormattedMessage
                id="checkout.CheckoutBankAccountMessage.message"
                defaultMessage="You won't be charged yet."
            />
        </div>
    );
};

export default createFragmentContainer(CheckoutBankAccountMessage, {
    transaction: graphql`
        fragment CheckoutBankAccountMessage_transaction on Transaction {
            isPrivateOffer
            isShippingKnownAtCheckout
        }
    `,
});
